import { FC, ReactElement } from 'react'

import { Page } from '@/components'
import { ConnectedLeaveOfAbsenceEdit } from '@/connectors'

export const AbsenceEditPage: FC = (): ReactElement => (
    <Page className="absence-edit-page">
        <ConnectedLeaveOfAbsenceEdit />
    </Page>
)
